import LoadingIndicator, { LoadingIndicatorProps } from "./LoadingIndicator";
import OverlayLoadingWrapper from "./overlays/LoadingWrapperOverlay";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type LoadingWrapperProps = {
  loadingIndicatorSize?: LoadingIndicatorProps["loadingIndicatorSize"];
  loadingIndicatorClassName?: string;
  children?: ReactNode;
  className?: string;
  overlayClassName?: string;
  zIndex?: number;
  isLoading: boolean;
};

const LoadingWrapper = ({
  children,
  isLoading,
  loadingIndicatorSize = "xl",
  className,
  loadingIndicatorClassName,
  overlayClassName,
  zIndex = 10,
}: LoadingWrapperProps) => {
  return (
    <div className={twMerge("h-full w-full", className)}>
      {isLoading && (
        <>
          <OverlayLoadingWrapper zIndex={zIndex} className={overlayClassName} />
          <div
            className="absolute left-1/2 top-1/2 !h-fit -translate-x-1/2 -translate-y-1/2"
            style={{ zIndex: zIndex + 1 }}
          >
            <LoadingIndicator
              loadingIndicatorSize={loadingIndicatorSize}
              className={twMerge("text-primary-main", loadingIndicatorClassName)}
            />
          </div>
        </>
      )}
      {children}
    </div>
  );
};

export default LoadingWrapper;
